/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const USE_FILE_STORE_MAPPINGS_STRINGS = {
  creatingMapping: 'Creating mapping in progress...',
  deletingMapping: 'Deleting mapping in progress...',
  deletingMappingSuccessful: 'Mapping deleted successfully.',
  error: 'An error occurred.',
  mappingCreationSuccessful: 'Mapping created successfully.',
  updatingMapping: 'Updating mapping in progress...',
  updatingMappingSuccessful: 'Mapping updated successfully.',
};
